import Icon from '@mdi/react'

import { Tooltip } from '@/components/ui/tooltip'
import { getDaysText, getDueOverDueText, getInfoIcon } from '@/store/tasksApprovals/utils'
import { ICompliance, TServiceNowChangesStates } from '@/types/tasksApprovals'
import { getServiceNowChangeReqIcon, isServiceNowChangeRequests } from '@/utils/approvals'

import Status from './Status'

const Container = ({ item }: { item: ICompliance }) => {
    const serviceNowChangeRequestIcon = isServiceNowChangeRequests(item) ? (
        <Tooltip
            content={item?.metadata?.state as TServiceNowChangesStates}
            css={{
                marginRight: '8px',
            }}
        >
            <Icon path={getServiceNowChangeReqIcon(item)} size="16px" />
        </Tooltip>
    ) : null
    const icon = (
        <>
            {serviceNowChangeRequestIcon}
            {item.overdueBy && getInfoIcon(item.overdueBy, 'overdue')}
            {item.dueIn && getInfoIcon(item.dueIn, 'duein')}
        </>
    )

    let text = ''

    if (item.overdueBy) {
        text = `${getDueOverDueText(item.overdueBy, 'overdue')} ${getDaysText(item.overdueBy, 'overdue')}`
    } else if (item.dueIn) {
        text = `${getDueOverDueText(item.dueIn, 'duein')} ${getDaysText(item.dueIn, 'duein')}`
    }

    const hasIcon =
        serviceNowChangeRequestIcon ||
        (item.overdueBy && getInfoIcon(item.overdueBy, 'overdue')) ||
        (item.dueIn && getInfoIcon(item.dueIn, 'duein'))

    return <Status icon={hasIcon ? icon : null} text={text} />
}

export default Container
